import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx';
import { saveAs as importedSaveAs } from 'file-saver';
import { MimeTypesEnum } from '../models/mime-types-enum.model';

@Injectable()
export class DownloadService {

  constructor() { }

  public exportAsExcelFile(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const fileName = excelFileName + '.xls';
    XLSX.writeFile(workbook, fileName, { bookType: 'xls' });
  }

  public exportAsCsvFile(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const fileName = excelFileName + '.csv';

    let csv = XLSX.utils.sheet_to_csv(worksheet, { FS: ';', strip: true });
    csv = csv.slice(0, -1);

    const fileCsv = new Blob([csv], { type: MimeTypesEnum.CSV });

    importedSaveAs(fileCsv, fileName);
  }

  private downloadFileFromByteArray(byteArray: Uint8Array, type: string, name: string) {
    importedSaveAs(new Blob([byteArray], { type: type }), name);
  }

  public downloadFileFromBase64String(base64: string, type: string, name: string) {
    const byteCharacters = atob(base64.toString());
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    this.downloadFileFromByteArray(new Uint8Array(byteNumbers), type, name);
  }

}
